import apolloClient from 'graphql/apollo';
import analyticsMutation from 'graphql/mutations/analytics/mutation.graphql';
import decamelizeKeys from 'util/decamelizeKeys';

import { BackendAnalyticsTrackInput } from '../types';

const backendAnalyticsTrack = (input: BackendAnalyticsTrackInput): void => {
  apolloClient.mutate({
    mutation: analyticsMutation,
    variables: {
      input: decamelizeKeys(input),
    },
  });
};

export default backendAnalyticsTrack;
